import {
  FUNC_DEFAULT,
  OBJECT_DEFAULT,
  RESET_PORTAL_MODAL_STORE,
  STRING_DEFAULT,
} from 'constants';
import { SET_PORTAL_MODAL } from 'store/action';
import { functionUtils, objectUtils } from 'utils';
import useStore from './useStore';

const usePortalModal = () => {
  const { dispatch } = useStore();

  const showPortalModal = (name) => {
    const payload = {
      name,
      title: STRING_DEFAULT,
      content: STRING_DEFAULT,
      action: FUNC_DEFAULT,
      actionClose: FUNC_DEFAULT,
      modalStyles: OBJECT_DEFAULT,
      modalOptions: OBJECT_DEFAULT,
      modalData: OBJECT_DEFAULT,
    };
    dispatch({
      type: SET_PORTAL_MODAL,
      payload: {
        isShowPortalModal: true,
        namePortalModal: name,
        ...payload,
      },
    });
  };

  const showPortalModalName = ({
    name,
    title,
    content,
    action,
    actionClose,
    modalStyles,
    modalOptions,
    modalData,
  }) => {
    dispatch({
      type: SET_PORTAL_MODAL,
      payload: {
        isShowPortalModal: true,
        namePortalModal: name,
        ...(title && { title }),
        ...(content && { content }),
        ...(functionUtils.isFunction(action) && { action }),
        ...(functionUtils.isFunction(actionClose) && { actionClose }),
        ...(objectUtils.isObject(modalStyles) && { modalStyles }),
        ...(objectUtils.isObject(modalOptions) && { modalOptions }),
        ...(objectUtils.isObject(modalData) && { modalData }),
      },
    });
  };

  const closePortalModalName = (name) => {
    dispatch({
      type: SET_PORTAL_MODAL,
      payload: RESET_PORTAL_MODAL_STORE,
    });
  };

  return {
    showPortalModal,
    showPortalModalName,
    closePortalModalName,
  };
};

export default usePortalModal;
